<template>
  <div>
    <!-- Barra de navegación fija -->
    <div class="fixed-top">
      <unloggedBar />
    </div>

    <!-- Contenido ajustado dinámicamente -->
    <div :style="{ marginTop: topPadding }">
      <router-view></router-view>
    </div>

    <!-- Footer -->
    <footer class="container-fluid bg-dark text-white pt-3">
      <div class="row justify-content-center text-center">
        <!-- Asociación Lakoma Section -->
        <div class="col-12 col-md-4 col-lg-3 mb-3">
          <img src="../assets/logo-blanco.png" style="width: 240px;" class="list-social-icon" alt="Asociación Lakoma Madrid">
        </div>
      </div>

      <!-- Copyright Section -->
      <div class="row justify-content-center">
        <div class="col-12 text-center">
          <p class="m-3">
            &copy; Copyright 2025 Agile Sin Filtros. Todos los derechos reservados. Desarrollado por Somosierra Tech S.L.&nbsp;|&nbsp;
            <a href="/avisolegal.html" class="text-white">Aviso legal</a>.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, onMounted, onUpdated, onBeforeUnmount } from "vue";
import unloggedBar from "./spares/UnloggedBar.vue";

const topPadding = ref("60px");

const updatePadding = () => {
  setTimeout(() => {
    const bar = document.querySelector(".fixed-top");
    if (bar) {
      topPadding.value = `${bar.offsetHeight}px`;
    }
  }, 100); // 100 ms de retraso
};

onMounted(() => {
  updatePadding(); // Llamamos a la función al montar el componente
  window.addEventListener("resize", updatePadding);
});

onUpdated(updatePadding);

onBeforeUnmount(() => {
  window.removeEventListener("resize", updatePadding);
});
</script>

